import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
  CambiarEstado(data) {
    return axios
      .post(`${domain.domainNameForApi}Sistemas/CambiarEstado`, data)
      .then((response) => response.data);
  },
  async ObtenerCatalogo(vm, tipo) {
    var formData = new FormData();
    formData.append("tipoCatalogo", tipo);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerCatalogo`,
      formData
    );
    if (tipo == "sitio") {
      vm.Sitio.CatalogoSitios = response.data;
    } else if (tipo == "modulo") {
      vm.Modulos.CatalogoModulos = response.data;
    }
  },
  async CatalogoAcortador(vm) {
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/CatalogoAcortador`
    );
    vm.Sitio.CatalogoSitios = response.data;
  },
  async EliminarURLAcortada(aclave) {
    var formData = new FormData();
    formData.append("aclave", aclave);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/EliminarURLAcortada`,
      formData
    );
    return response.data;
  },
  GuardarReporte(data) {
    return axios
      .post(`${domain.domainNameForApi}Sistemas/GuardarReporte`, data)
      .then((response) => response.data);
  },
  ExisteProcedimiento(data) {
    return axios
      .post(`${domain.domainNameForApi}Sistemas/ExisteProcedimiento`, data)
      .then((response) => response.data);
  },
  ObtenerDatos(data) {
    return axios
      .post(`${domain.domainNameForApi}Sistemas/ObtenerDatos`, data)
      .then((response) => response.data);
  },
  ObtenerCorreos(data) {
    return axios
      .post(`${domain.domainNameForApi}Sistemas/ObtenerCorreos`, data)
      .then((response) => response.data);
  },
  async EditarURLAcortada(saclave, longURL, aclave, uslogin) {
    var formData = new FormData();
    formData.append("saclave", saclave);
    formData.append("longURL", longURL);
    formData.append("aclave", aclave);
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/EditarURLAcortada`,
      formData
    );
    return response.data;
  },
  async AgregarURLAcortada(saclave, longURL, uslogin) {
    var formData = new FormData();
    formData.append("saclave", saclave);
    formData.append("longURL", longURL);
    formData.append("uslogin", uslogin);

    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/AgregarURLAcortada`,
      formData
    );
    return response.data;
  },
  EnviarMensaje(data) {
    return axios
      .post(`${domain.domainNameForApi}Sistemas/EnviarMensaje`, data)
      .then((response) => response.data);
  },
  async ObtenerPerfiles(vm, perfil) {
    var formData = new FormData();
    formData.append("perfil", perfil);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerPerfiles`,
      formData
    );
    if (perfil == "usuario") {
      vm.Perfiles.CatalogoPerfiles = response.data;
    } else if (perfil == "correo") {
      vm.PerfilCorreo.CatalogoPerfilCorreo = response.data;
    } else if (perfil == "telefono") {
      vm.PerfilTelefono.CatalogoPerfilTel = response.data;
    }
  },
  async ObtenerUsuarios(vm) {
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerUsuarios`
    );
    vm.Usuarios.CatalogoUsuarios = response.data;
  },
  EjecutarTarea(data) {
    return axios
      .post(`${domain.domainNameForApi}Sistemas/EjecutarTarea`, data)
      .then((response) => response.data);
  },
  async AltaProceso(proceso, uslogin) {
    var formData = new FormData();
    formData.append("ntproceso", proceso.ntproceso);
    formData.append("nttxtnotificacion", proceso.nttxtnotificacion);
    formData.append("nttxtcorreo", proceso.nttxtcorreo);
    formData.append("nttxtsms", proceso.nttxtsms);
    formData.append("ntsitio", proceso.ntsitio);
    formData.append("ntmodulo", proceso.ntmodulo);
    formData.append("dnuslogin", proceso.dnuslogin);
    formData.append("pfclaveUsuarios", proceso.pfclaveUsuarios);
    formData.append("dnemail", proceso.dnemail);
    formData.append("pfclaveCorreos", proceso.pfclaveCorreos);
    formData.append("dnemailcc", proceso.dnemailcc);
    formData.append("pfclaveCorreoscc", proceso.pfclaveCorreoscc);
    formData.append("dnemailcco", proceso.dnemailcco);
    formData.append("pfclaveCorreoscco", proceso.pfclaveCorreoscco);
    formData.append("pfclaveTelefono", proceso.pfclaveTelefono);
    formData.append("dnTelefono", proceso.dnTelefono);
    formData.append("ticlave", proceso.ticlave);
    formData.append("nttxtwhatsapp", proceso.nttxtwhatsapp);
    formData.append("nttxtwhatsappUS", proceso.nttxtwhatsappUS);
    formData.append("nttemplatews", proceso.nttemplatews);
    formData.append("nttxtpushnotificacion", proceso.nttxtpushnotificacion);
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/AltaProceso`,
      formData
    );
    return response.data;
  },
  async DetalleProceso(vm, ntclave) {
    var formData = new FormData();
    formData.append("ntclave", ntclave);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/DetalleProceso`,
      formData
    );
    let proceso = response.data[0];
    vm.alta = {
      proceso: proceso.ntproceso == "" ? null : proceso.ntproceso,
      sitio: proceso.ntsitio == "" ? null : proceso.ntsitio,
      modulo: proceso.ntmodulo == "" ? null : proceso.ntmodulo,
      ntclave: proceso.ntclave,
    };
    const sitioSeleccionado = vm.Sitio.CatalogoSitios.find(
      (sitio) => sitio.ntsitio === proceso.ntsitio
    );
    vm.alta.sitio = sitioSeleccionado || null;
    vm.altanoti = {
      textNoti: proceso.nttxtnotificacion,
      usuario: [],
      perfil: [],
      switch: null,
    };
    vm.altacorreo = {
      textcorreo: proceso.nttxtcorreo,
      switch: null,
      pcorreo: [],
      pcorreocopia: [],
      pcorreocopiaoculta: [],
    };
    vm.altasms = {
      textsms: proceso.nttxtsms,
      switch: null,
      perfilTel: [],
    };
    vm.altaWhatsapp = {
      textWhatsapp: proceso.nttxtwhatsapp,
      txtWhatsappUS: proceso.nttxtwhatsappUS,
      nameTemplate: proceso.nttemplatews == "" ? "" : proceso.nttemplatews,
      switch: null,
    };
    vm.altapush = {
      textNotiPush: proceso.nttxtpushnotificacion,
    };
  },

  async DetalleAsignacionNotificacion(vm, ntclave) {
    var formData = new FormData();
    formData.append("ntclave", ntclave);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/DetalleAsignacionNotificacion`,
      formData
    );
    let proceso = response.data;
    let usuariosTransformados = proceso
      .filter((item) => item.dnuslogin != "")
      .map((item) => {
        return {
          Login: item.dnuslogin,
          descrip: item.desc,
          Nombre: item.Nombre,
          Puesto: item.Puesto,
          Estatus: item.Estatus,
          Bloqueada: item.Bloqueada,
        };
      });
    vm.altanoti.usuario = usuariosTransformados;
    let perfiles = proceso
      .filter((item) => item.pfclaveUsuarios != "")
      .map((item) => {
        return {
          pfdesc: item.pfclaveUsuarios,
          pfclave: item.perfilclave,
        };
      });
    vm.altanoti.perfil = perfiles;
    let perfilcorreo = proceso
      .filter((item) => item.pfclaveCorreos != "")
      .map((item) => {
        return {
          pfdesc: item.pfclaveCorreos,
          pfclave: item.pfidcorreo,
        };
      });
    vm.altacorreo.pcorreo = perfilcorreo;
    let perfilcc = proceso
      .filter((item) => item.pfclaveCorreoscc != "")
      .map((item) => {
        return {
          pfdesc: item.pfclaveCorreoscc,
          pfclave: item.pfidcc,
        };
      });
    vm.altacorreo.pcorreocopia = perfilcc;
    let perfilco = proceso
      .filter((item) => item.pfclaveCorreoscco != "")
      .map((item) => {
        return {
          pfdesc: item.pfclaveCorreoscco,
          pfclave: item.pfidco,
        };
      });
    vm.altacorreo.pcorreocopiaoculta = perfilco;
    proceso.filter((item) => {
      if (item.dnemail != "") {
        vm.correos.selectedItems.push(item.dnemail);
      } else if (item.dnemailcc != "") {
        vm.correosCopia.selectedItems.push(item.dnemailcc);
      } else if (item.dnemailcco != "") {
        vm.correosCO.selectedItems.push(item.dnemailcco);
      } else if (item.dnTelefono != "") {
        vm.telefonos.selectedItems.push(item.dnTelefono);
      }
    });
    let perfiltel = proceso
      .filter((item) => item.pfclaveTelefono != "")
      .map((item) => {
        return {
          pfdesc: item.pfclaveTelefono,
          pfclave: item.pfidtel,
        };
      });
    vm.altasms.perfilTel = perfiltel;
  },
  async ActualizarProceso(proceso, uslogin) {
    var formData = new FormData();
    formData.append("ntclave", proceso.ntclave);
    formData.append("ntproceso", proceso.ntproceso);
    formData.append("nttxtnotificacion", proceso.nttxtnotificacion);
    formData.append("nttxtcorreo", proceso.nttxtcorreo);
    formData.append("nttxtsms", proceso.nttxtsms);
    formData.append("ntsitio", proceso.ntsitio);
    formData.append("ntmodulo", proceso.ntmodulo);
    formData.append("dnuslogin", proceso.dnuslogin);
    formData.append("pfclaveUsuarios", proceso.pfclaveUsuarios);
    formData.append("dnemail", proceso.dnemail);
    formData.append("pfclaveCorreos", proceso.pfclaveCorreos);
    formData.append("dnemailcc", proceso.dnemailcc);
    formData.append("pfclaveCorreoscc", proceso.pfclaveCorreoscc);
    formData.append("dnemailcco", proceso.dnemailcco);
    formData.append("pfclaveCorreoscco", proceso.pfclaveCorreoscco);
    formData.append("pfclaveTelefono", proceso.pfclaveTelefono);
    formData.append("dnTelefono", proceso.dnTelefono);
    formData.append("ticlave", proceso.ticlave);
    formData.append("nttxtwhatsapp", proceso.nttxtwhatsapp);
    formData.append("nttxtwhatsappUS", proceso.nttxtwhatsappUS);
    formData.append("nttemplatews", proceso.nttemplatews);
    formData.append("nttxtpushnotificacion", proceso.nttxtpushnotificacion);
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ActualizarProceso`,
      formData
    );
    return response.data;
  },
  async ObtenerDetalleUsuario(uslogin) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerDetalleUsuario`,
      formData
    );
    return response.data[0];
  },
  async GenerarTarificador(uslogin, acd, action) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("acd", acd);
    formData.append("action", action);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/GenerarTarificador`,
      formData
    );
    return response.data;
  },
  async GenerarACD(uslogin, tarificador, action) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    if (tarificador) formData.append("tarificador", tarificador);
    formData.append("action", action);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/GenerarACD`,
      formData
    );
    return response.data;
  },
  async EnviarPasswordXCorreo(uslogin, correos) {
    var formData = new FormData();
    formData.append("usloginAlta", MetodosGenerales.ObtenerUserName());
    formData.append("uslogin", uslogin);
    formData.append("correos", correos);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/EnviarPasswordXCorreo`,
      formData
    );

    console.log("la respuesta del EnviarPasswordXCorreo: ", response);

    return response.data;
  },
  async ObtenerBloqueosUsuario(uslogin) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerBloqueosUsuario`,
      formData
    );
    return response.data;
  },
  async DesbloquearUsuario(uslogin, idBloqueo) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("idBloqueo", idBloqueo);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/DesbloquearUsuario`,
      formData
    );
    return response.data;
  },
  async ObtenerPuestos(area) {
    var formData = new FormData();
    formData.append("area", area);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerPuestos`,
      formData
    );
    return response.data;
  },
  async ObtenerJefes(uslogin, direccion, puesto) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("direccion", direccion);
    formData.append("puesto", puesto);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerJefesDeDireccion`,
      formData
    );
    return response.data;
  },
  async validaCorreos(uslogin, correos) {
    var formData = new FormData();
    formData.append("correos", correos);
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/validaCorreos`,
      formData
    );
    return response.data;
  },
  async VerificarContrasenaFirma(uslogin, password) {
    var formData = new FormData();
    formData.append("password", password);
    formData.append("uslogin", uslogin); //MetodosGenerales.ObtenerUserName());
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/VerificarContrasenaFirma`,
      formData
    );
    return response.data;
  },
  async VerificarCoincidenciasContrasenas(uslogin, passwordAnt, password) {
    var formData = new FormData();
    formData.append("ContAnterior", passwordAnt);
    formData.append("ContNueva", password);
    formData.append("uslogin", uslogin); //MetodosGenerales.ObtenerUserName());
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/VerificarCoincidenciasContrasenas`,
      formData
    );
    return response.data;
  },
  async VerificarContenidoContrasena(uslogin, password) {
    var formData = new FormData();
    formData.append("ContNueva", password);
    formData.append("uslogin", uslogin); //MetodosGenerales.ObtenerUserName());
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/VerificarContenidoContrasena`,
      formData
    );
    return response.data;
  },
  async VerificarHistorialContrasena(uslogin, password) {
    var formData = new FormData();
    formData.append("ContNueva", password);
    formData.append("uslogin", uslogin); //MetodosGenerales.ObtenerUserName());
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/VerificarHistorialContrasena`,
      formData
    );
    return response.data;
  },
  async ActualizarDatosUsuario(
    uslogin,
    tipoUsuario,
    correos,
    passwordActual,
    passwordNueva,
    puid,
    usfecnac,
    usext,
    usagentlogin,
    jefeusid,
    empfecingresoSS
  ) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("tipoUsuario", tipoUsuario);
    formData.append("correos", correos);
    formData.append("puid", puid);
    formData.append("usfecnac", usfecnac);
    formData.append("empfecingresoSS", empfecingresoSS);
    formData.append("usext", usext);
    formData.append("usagentlogin", usagentlogin);
    formData.append("jefeusid", jefeusid);
    formData.append("passwordActual", passwordActual);
    formData.append("passwordNueva", passwordNueva);
    formData.append("usext", passwordNueva);
    formData.append("usagentlogin", passwordNueva);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ActualizarDatosUsuario`,
      formData
    );
    return response.data;
  },
  async ObtenerClientes() {
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerClientes`
    );
    return response.data;
  },
  async ActualizarDatosCliente(uslogin, clclave, gfclave, ageid, oepclave) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("clclave", clclave);
    if (gfclave) formData.append("gfclave", gfclave);
    if (ageid) formData.append("ageid", ageid);
    if (oepclave !== null) formData.append("oepclave", oepclave);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ActualizarDatosCliente`,
      formData
    );
    return response.data;
  },
  async ObtenerEstados() {
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerEstados`
    );
    return response.data;
  },
  async ObtenerLocalidades(esclave) {
    var formData = new FormData();
    if (esclave) formData.append("esclave", esclave);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerLocalidades`,
      formData
    );
    return response.data;
  },
  async ActualizarLocalidad(uslogin, loclave) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("loclave", loclave);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ActualizarLocalidad`,
      formData
    );
    return response.data;
  },
  async SubirFotoPerfil(uslogin, upuslogin, file, rutaActual) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("upuslogin", upuslogin);
    formData.append("file", file);
    if (rutaActual) formData.append("rutaActual", rutaActual);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/SubirFotoPerfil`,
      formData
    );
    return response.data;
  },
  async ObtenerFotoPerfil(ruta, uslogin) {
    var formData = new FormData();
    formData.append("ruta", ruta);
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerFotoPerfil`,
      formData
    );
    return response.data;
  },
  async ObtenerOficinas(clclave) {
    var formData = new FormData();
    formData.append("clclave", clclave);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerOficinas`,
      formData
    );
    return response.data;
  },
  ObtenerHora() {
    return axios
      .post(`${domain.domainNameForApi}Sistemas/ObtenerHora`)
      .then((response) => response.data);
  },
  async GuardarPermisos(uslogin, peclaves, upuslogin, upvalor) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("peclaves", peclaves);
    formData.append("upuslogin", upuslogin);
    formData.append("upvalor", upvalor);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/AgregarPermisosUsuario`,
      formData
    );
    return response.data;
  },
  async EliminarPermisos(uslogin, peclaves) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("peclaves", peclaves);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/EliminarPermisosUsuario`,
      formData
    );
    return response.data;
  },
  async EliminarArchvo() {
    let data = 1;
    var formData = new FormData();
    formData.append("data", data);
    let response = await axios.post(
      `${domain.domainNameForApi}EliminarArchivo`
    );
    return response.data;
  },
  async DarDeBajaUsuario(uslogin) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/DarDeBajaUsuario`,
      formData
    );
    return response.data;
  },
  async ReactivarUsuario(uslogin) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ReactivarUsuario`,
      formData
    );
    return response.data;
  },
  async BuscarUsuario(usuario, activo, tipo) {
    var formData = new FormData();
    formData.append("uslogin", usuario);
    formData.append("activo", activo);
    formData.append("tipoInterno", tipo);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/BuscarUsuarioClonar`,
      formData
    );
    return response.data;
  },
  async ObtenerPerfilesAdministracion() {
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerPerfilesAdministracion`
    );
    return response.data;
  },
  async ClonarPermisos(usloginAlta, usloginOrigen, usloginDestino) {
    var formData = new FormData();
    formData.append("usloginAlta", usloginAlta);
    formData.append("usloginOrigen", usloginOrigen);
    formData.append("usloginDestino", usloginDestino);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ClonarPermisos`,
      formData
    );
    return response.data;
  },
  async GenerarIVR(uslogin, permisoPerfil, usloginAlta) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("permisoPerfil", permisoPerfil);
    formData.append("usloginAlta", usloginAlta);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/GenerarIVR`,
      formData
    );
    return response.data;
  },
  async PrepararFirmaElectronica(uslogin) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/PrepararFirmaElectronica`,
      formData
    );
    return response.data;
  },
  async ObtenerTiposEjecutivo() {
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/TiposEjecutivos`
    );
    return response.data;
  },
  async ObtenerGerencias() {
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerGerencias`
    );
    return response.data;
  },
  async ObtenerSupervisorias(geclave) {
    var formData = new FormData();
    formData.append("geclave", geclave);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerSupervisorias`,
      formData
    );
    return response.data;
  },
  async ObtenerAbogados(busqueda) {
    var formData = new FormData();
    formData.append("busqueda", busqueda);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerAbogados`,
      formData
    );
    return response.data;
  },
  async ActualizarDatosPerfil(
    usloginAlta,
    perfilActual,
    perfilNuevo,
    permisoPerfilActual,
    permisoPerfilNuevo,
    uslogin,
    usvalorActual,
    usvalorNuevo,
    correos,
    cuentasNuevas,
    tipoEjecutivo,
    accionPermiso
  ) {
    var formData = new FormData();
    formData.append("usloginAlta", usloginAlta);
    formData.append("perfilActual", perfilActual);
    formData.append("perfilNuevo", perfilNuevo);
    formData.append("permisoPerfilActual", permisoPerfilActual);
    formData.append("permisoPerfilNuevo", permisoPerfilNuevo);
    formData.append("uslogin", uslogin);
    formData.append("usvalorActual", usvalorActual);
    formData.append("usvalorNuevo", usvalorNuevo);
    formData.append("correos", correos);
    if (cuentasNuevas && cuentasNuevas.length)
      formData.append("cuentasNuevas", cuentasNuevas);
    if (tipoEjecutivo) formData.append("tipoEjecutivo", tipoEjecutivo);
    formData.append("accionPermiso", accionPermiso);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ActualizarDatosPerfil`,
      formData
    );
    return response.data;
  },
  async ObtenerAgentes(clclave, busqueda) {
    var formData = new FormData();
    formData.append("clclave", clclave);
    formData.append("busqueda", busqueda);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerAgentes`,
      formData
    );
    return response.data;
  },
  async ObtenerFlotillas(clclave) {
    var formData = new FormData();
    formData.append("clclave", clclave);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerFlotillas`,
      formData
    );
    return response.data;
  },
  async ObtenerModulos(uslogin) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerModulos`,
      formData
    );
    return response.data;
  },
  async ObtenerModulosUsuario(uslogin) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerModulosUsuario`,
      formData
    );
    return response.data;
  },
  async EnviarCorreoAExterno(nombreCompleto, uslogin, correos, usEmisor) {
    var formData = new FormData();
    formData.append("nombreCompleto", nombreCompleto);
    formData.append("uslogin", uslogin);
    formData.append("correos", correos);
    formData.append("usEmisor", usEmisor);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/EnviarCorreoAExterno`,
      formData
    );
    return response.data;
  },

  async ObtenerAreas() {
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerAreas`
    );
    return response.data;
  },
  async GenerarLogin(nombre, paterno, materno, reactivar) {
    var formData = new FormData();
    formData.append("nombre", nombre);
    formData.append("paterno", paterno);
    formData.append("materno", materno);
    formData.append("reactivar", reactivar);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/GenerarLogin`,
      formData
    );
    return response.data;
  },
  async InsertarInterno(
    uslogin,
    usperfil,
    peclavePerfil,
    usvalor,
    accionPerfil,
    tipoEjecutivo,
    cuentas,
    puesto,
    nombres,
    paterno,
    materno,
    fecha_nacimiento,
    rfc,
    correos,
    loclave,
    esquema,
    usidJefe,
    pauid,
    puestoDesc,
    pauautpend
  ) {
    var formData = new FormData();
    formData.append("upuslogin", MetodosGenerales.ObtenerUserName());
    formData.append("uslogin", uslogin);
    formData.append("usperfil", usperfil);
    formData.append("peclavePerfil", peclavePerfil);
    formData.append("usvalor", usvalor);
    formData.append("accionPerfil", accionPerfil);
    formData.append("tipoEjecutivo", tipoEjecutivo);
    formData.append("cuentas", cuentas); //muchos
    formData.append("puesto", puesto);
    formData.append("nombres", nombres);
    formData.append("paterno", paterno);
    formData.append("materno", materno);
    formData.append("fecha_nacimiento", fecha_nacimiento);
    formData.append("rfc", rfc);
    formData.append("correos", correos);
    formData.append("loclave", loclave);
    formData.append("esquema", esquema);
    formData.append("usidJefe", usidJefe);
    formData.append("pauid", pauid);
    formData.append("puestoDesc", puestoDesc);
    formData.append("pauautpend", pauautpend);

    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/InsertarInterno`,
      formData
    );
    return response.data;
  },

  async InsertarExterno(
    uslogin,
    cliente,
    flotilla,
    agente,
    nombres,
    paterno,
    materno,
    correos,
    pauid
  ) {
    var formData = new FormData();
    formData.append("upuslogin", MetodosGenerales.ObtenerUserName());
    formData.append("uslogin", uslogin);
    formData.append("cliente", cliente);
    formData.append("flotilla", flotilla);
    formData.append("agente", agente);
    formData.append("nombres", nombres);
    formData.append("paterno", paterno);
    formData.append("materno", materno);
    formData.append("correos", correos);
    formData.append("pauid", pauid);

    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/InsertarExterno`,
      formData
    );
    return response.data;
  },
  async ListadoSolicitudesAutorizadas() {
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ListadoSolicitudesAutorizadas`
    );
    return response.data;
  },
  async ValidaUsuariosAsignados(uslogin) {
    var formData = new FormData();
    formData.append("uslogin", uslogin); //MetodosGenerales.ObtenerUserName());
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ValidaUsuariosAsignados`,
      formData
    );
    return response.data;
  },
  async AsignarJefe(uslogin, usidnuevoJefe) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("usidnuevoJefe", usidnuevoJefe);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/AsignarJefe`,
      formData
    );
    return response.data;
  },
  async VerificarUslogin(uslogin) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/VerificarUslogin`,
      formData
    );
    return response.data;
  },
  async GenerarLoginCliente(nombre, paterno, materno, cliente) {
    var formData = new FormData();
    formData.append("nombre", nombre);
    formData.append("paterno", paterno);
    formData.append("materno", materno);
    formData.append("clclave", cliente);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/GenerarLoginCliente`,
      formData
    );
    return response.data;
  },
  async ConsultarOpenAI() {
    var formData = new FormData();
    formData.append("uslogin", MetodosGenerales.ObtenerUserName());
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ConsultarOpenAI`,
      formData
    );
    return response.data;
  },
  async DatosaConsultar(tipo) {
    var formData = new FormData();
    formData.append("showvh", tipo);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/DatosaConsultar`,
      formData
    );
    return response.data;
  },
  async ComprobarCitaOpenAI(nrreportes, svindices, fechas) {
    var formData = new FormData();
    formData.append("nrreportes", nrreportes);
    formData.append("svindices", svindices);
    formData.append("fechas", fechas);

    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ComprobarCitaOpenAI`,
      formData
    );
    return response.data;
  },
  async ConsultarOpenAIVH() {
    var formData = new FormData();
    formData.append("uslogin", MetodosGenerales.ObtenerUserName());
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ConsultarOpenAIVH`,
      formData
    );
    return response.data;
  },
  async ComprobarDocumento(nrreportes, svindices) {
    var formData = new FormData();
    formData.append("nrreportes", nrreportes);
    formData.append("svindices", svindices);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ComprobarDocumento`,
      formData
    );
    return response.data;
  },
  async ObtenerLineasCI() {
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtenerLineasCI`
    );
    return response.data;
    //vm.Usuarios.CatalogoUsuarios = response.data;
  },
  async valFirmaElectronica(usfirma) {
    var formData = new FormData();
    formData.append("usfirma", usfirma);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ValFirmaElectronica`,
      formData
    );
    return response.data;
  },
  async ObtienelineaCISeleccionada() {
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ObtienelineaCISeleccionada`
    );
    return response.data;
  },
  async InsertaCambioCI(caclinea, CIAusaAseg, CIAsegAusa) {
    var formData = new FormData();
    formData.append("caclinea", caclinea);
    formData.append("uslogin", MetodosGenerales.ObtenerUserName());
    formData.append("CIAusaAseg", CIAusaAseg);
    formData.append("CIAsegAusa", CIAsegAusa);

    return await axios
      .post(`${domain.domainNameForApi}Sistemas/InsertaCambioCI`, formData)
      .then((response) => response.data);
  },
  async ReactivarUsuarioPrealta(
    uslogin,
    usperfil,
    peclavePerfil,
    usvalor,
    accionPerfil,
    tipoEjecutivo,
    cuentas,
    puesto,
    nombres,
    paterno,
    materno,
    fecha_nacimiento,
    rfc,
    correos,
    loclave,
    esquema,
    usidJefe,
    pauid,
    puestoDesc,
    pauautpend
  ) {
    var formData = new FormData();
    formData.append("upuslogin", MetodosGenerales.ObtenerUserName());
    formData.append("uslogin", uslogin);
    formData.append("usperfil", usperfil);
    formData.append("peclavePerfil", peclavePerfil);
    formData.append("usvalor", usvalor);
    formData.append("accionPerfil", accionPerfil);
    formData.append("tipoEjecutivo", tipoEjecutivo);
    formData.append("cuentas", cuentas); //muchos
    formData.append("puesto", puesto);
    formData.append("nombres", nombres);
    formData.append("paterno", paterno);
    formData.append("materno", materno);
    formData.append("fecha_nacimiento", fecha_nacimiento);
    formData.append("rfc", rfc);
    formData.append("correos", correos);
    formData.append("loclave", loclave);
    formData.append("esquema", esquema);
    formData.append("usidJefe", usidJefe);
    formData.append("pauid", pauid);
    formData.append("puestoDesc", puestoDesc);
    formData.append("pauautpend", pauautpend);
    let response = await axios.post(
      `${domain.domainNameForApi}Sistemas/ReactivarUsuarioPrealta`,
      formData
    );
    return response.data;
  },
};
